import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TCreateInstantPayPayoutRequest,
  TCreateInstantPayPayoutResponse,
} from "./createInstantPayPayout.schema";

export const createInstantPayPayout =
  (axios: IAxiosInstance) =>
  async (
    params: TCreateInstantPayPayoutRequest
  ): Promise<TCreateInstantPayPayoutResponse> => {
    const response = await axios.noRetry.post(
      "/api/charges-and-fees/instant-pay-payout",
      params
    );
    const resData = response.data;

    if (resData?.success) {
      return resData;
    }

    throw new Error(resData?.error || "Error creating instant pay payout");
  };
